module.exports = __webpack_public_path__ + "img/ic_visa_transfer.90347b26.png";